// App action constants
const APP_SHOW_HIDE_ADMIN_MODAL = 'APP/SHOW_HIDE_ADMIN_MODAL';

// App actions/thunks
export const showHideAdminModal = ({ show }) => ({
  type: APP_SHOW_HIDE_ADMIN_MODAL,
  payload: { show }
});

// App reducer
export const appReducerKey = 'app';
export const appReducer = (state = { showAdminModal: false }, action) => {
  switch (action.type) {
    case APP_SHOW_HIDE_ADMIN_MODAL:
      return { ...state, showAdminModal: action.payload.show };
    default:
      return state;
  }
};

// App selectors
export const showAdminModal = state => state[appReducerKey].showAdminModal;
